import SvgIconStyle from 'components/SvgIconStyle';
import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined';
import ExtensionOutlined from '@mui/icons-material/ExtensionOutlined';
import HubOutlined from '@mui/icons-material/HubOutlined';
import FunctionsOutlined from '@mui/icons-material/FunctionsOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import SpaceDashboard from '@mui/icons-material/SpaceDashboard';
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import ScienceOutlined from '@mui/icons-material/ScienceOutlined';
import AttachMoneyOutlined from '@mui/icons-material/AttachMoneyOutlined';
import StickyNote2Outlined from '@mui/icons-material/StickyNote2Outlined';
import PublicOutlined from '@mui/icons-material/PublicOutlined';
import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined';
import LocationCityOutlined from '@mui/icons-material/LocationCityOutlined';
import DnsOutlined from '@mui/icons-material/DnsOutlined';
import StorageOutlined from '@mui/icons-material/StorageOutlined';
import BuildCircleOutlined from '@mui/icons-material/BuildCircleOutlined';
import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import TuneOutlined from '@mui/icons-material/TuneOutlined';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import NotificationsActiveOutlined from '@mui/icons-material/NotificationsActiveOutlined';
import MarkEmailReadOutlined from '@mui/icons-material/MarkEmailReadOutlined';
import ApiOutlined from '@mui/icons-material/ApiOutlined';
import PermMediaOutlined from '@mui/icons-material/PermMediaOutlined';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import EngineeringOutlined from '@mui/icons-material/EngineeringOutlined';
import { PATH_APP } from './paths';

const getIcon = (name, folder = 'navbar') => (
  <SvgIconStyle src={`/static/icons/${folder}/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  dashboard: getIcon('ic_analytics'),
  user: getIcon('user'),
  plan: getIcon('medal'),
  module: getIcon('puzzle'),
  industry: getIcon('factory'),
  documentType: getIcon('inventory'),
  quote: getIcon('invoice'),
  kanban: getIcon('kanban-flow'),
  security: getIcon('settings'),
  contractTemplate: getIcon('signature'),
  contract: getIcon('signature'),
  company: getIcon('home'),
  kanbanTemplate: getIcon('process'),
  chat: getIcon('query'),
  release: getIcon('process'),
  area: <ExtensionOutlined fontSize="small" />,
  priority: getIcon('medal'),
  capacityCalendar: <AccessTimeOutlined fontSize="small" />,
  calendarCategory: <HubOutlined fontSize="small" />,
  quoteFormula: <FunctionsOutlined fontSize="small" />,
  quoteDoc: <DescriptionOutlined fontSize="small" />,
  kanbanCompact: <SpaceDashboard fontSize="small" />,
  calendar: <CalendarMonthOutlined fontSize="small" />,
  product: <ScienceOutlined fontSize="small" />,
  priceList: <AttachMoneyOutlined fontSize="small" />,
  currency: <AttachMoneyOutlined fontSize="small" />,
  postit: <StickyNote2Outlined fontSize="small" />,
  country: <PublicOutlined fontSize="small" />,
  state: <AccountTreeOutlined fontSize="small" />,
  city: <LocationCityOutlined fontSize="small" />,
  infraDashboard: <SpaceDashboard fontSize="small" />,
  infraServer: <DnsOutlined fontSize="small" />,
  infraRuntime: <StorageOutlined fontSize="small" />,
  infraOps: <BuildCircleOutlined fontSize="small" />,
  infraSchedule: <CalendarMonthOutlined fontSize="small" />,
  infraPack: <WidgetsOutlined fontSize="small" />,
  infraPackVersion: <Inventory2Outlined fontSize="small" />,
  infraBinding: <LinkOutlined fontSize="small" />,
  infraAlert: <WarningAmberOutlined fontSize="small" />,
  infraSettings: <TuneOutlined fontSize="small" />,
  userMail: <EmailOutlined fontSize="small" />,
  notificationRule: <NotificationsActiveOutlined fontSize="small" />,
  notificationDispatch: <MarkEmailReadOutlined fontSize="small" />,
  api: <ApiOutlined fontSize="small" />,
  storageConfig: <PermMediaOutlined fontSize="small" />,
  requirement: <AssignmentOutlined fontSize="small" />,
  process: <EngineeringOutlined fontSize="small" />,
};

const buildSidebarConfig = ({
  showAreaCalendar = true,
  showAreaKanban = true,
  showAreaPostIt = true,
  showQuotes = true
} = {}) => [
    {
      subheader: 'Dashboards',
      items: [
        {
          title: 'Dashboard',
          path: PATH_APP.dashboard,
          icon: ICONS.dashboard,
          permissions: 'admin:dashboard:list'
        },
        {
          title: 'Dashboard Cliente',
          path: PATH_APP.clientDashboard,
          icon: ICONS.user,
          permissions: 'admin:client_dashboard:list'
        }
      ]
    },
    {
      subheader: 'Configuración',
      items: [
        {
          title: 'Mi Empresa',
          icon: ICONS.company,
          children: [
            {
              title: 'Mi empresa',
              path: PATH_APP.companyProfile,
              permissions: 'admin:company_profile:show'
            },
            {
              title: 'Almacenamiento',
              path: PATH_APP.storageConfig,
              permissions: 'admin:storage_config:manage'
            },
            {
              title: 'Áreas de trabajo',
              path: PATH_APP.workAreas,
              permissions: 'admin:work_areas:list'
            },
            {
              title: 'Calendario de capacidad',
              path: PATH_APP.areaCapacityCalendar,
              permissions: 'admin:area_capacity_calendar:list'
            },
            {
              title: 'Categorías calendario',
              path: PATH_APP.calendarCategories,
              permissions: 'admin:calendar_categories:list'
            },
            {
              title: 'Estados de cliente',
              path: PATH_APP.clientStatuses,
              permissions: 'admin:client_statuses:list'
            },
          ]
        },
        {
          title: 'Clientes',
          icon: ICONS.user,
          children: [
            {
              title: 'Países',
              path: PATH_APP.countries,
              permissions: 'admin:countries:list'
            },
            {
              title: 'Departamentos / Estados',
              path: PATH_APP.states,
              permissions: 'admin:states:list'
            },
            {
              title: 'Ciudades',
              path: PATH_APP.cities,
              permissions: 'admin:cities:list'
            },
            {
              title: 'Tipos de documento',
              path: PATH_APP.documentTypes,
              permissions: 'admin:document_types:list'
            },
            {
              title: 'Tipos de Industria',
              path: PATH_APP.industries,
              permissions: 'admin:industries:list'
            },
            {
              title: 'Plantillas de contrato',
              path: PATH_APP.contractTemplates,
              permissions: 'admin:contract_templates:list'
            },
          ]
        },
        {
          title: 'Cartera',
          icon: ICONS.quote,
          children: [
            {
              title: 'Cartera / Cobranza',
              path: PATH_APP.cartera,
              permissions: 'admin:cartera:list'
            },
            {
              title: 'Configuración de cartera',
              path: PATH_APP.carteraSettings,
              permissions: 'admin:cartera:manage'
            },
          ]
        },
        {
          title: 'Kanban',
          icon: ICONS.kanbanCompact,
          children: [
            {
              title: 'Prioridades Kanban',
              path: PATH_APP.kanbanPriorities,
              permissions: 'admin:kanban_priorities:list'
            },
            {
              title: 'Plantillas de formularios',
              path: PATH_APP.formDesignerForms,
              permissions: 'admin:form_designer_forms:list'
            },
            {
              title: 'Plantillas Kanban',
              path: PATH_APP.kanbanCardTemplates,
              permissions: 'admin:kanban_card_templates:list'
            },
          ]
        },
        {
          title: 'Requerimientos',
          icon: ICONS.requirement,
          children: [
            {
              title: 'Procesos',
              path: PATH_APP.processes,
              permissions: 'admin:processes:list'
            },
            {
              title: 'Plantillas',
              path: PATH_APP.requirementTemplates,
              permissions: 'admin:requirement_templates:list'
            },
          ]
        },
        {
          title: 'Cotizaciones',
          icon: ICONS.quote,
          children: [
            {
              title: 'Variables de cotización',
              path: PATH_APP.quoteVariables,
              permissions: 'admin:quote_variable_definitions:list'
            },
            {
              title: 'Fórmulas de cotización',
              path: PATH_APP.quoteFormulaDefinitions,
              permissions: 'admin:quote_formula_definitions:list'
            },
            {
              title: 'Variables por cliente',
              path: PATH_APP.clientQuoteVariables,
              permissions: 'admin:client_quote_variable_values:list'
            },
            {
              title: 'Plantillas de cotización',
              path: PATH_APP.quoteProposalTemplates,
              permissions: 'admin:quote_proposal_templates:list'
            },
          ]
        },
        {
          title: 'Notificaciones',
          icon: ICONS.notificationRule,
          children: [
            {
              title: 'Mi correo saliente',
              path: PATH_APP.userMailAccount,
              permissions: 'admin:mail_accounts:manage_own'
            },
            {
              title: 'Plantillas notificación',
              path: PATH_APP.notificationTemplates,
              permissions: 'admin:notifications:templates:manage'
            },
            {
              title: 'Reglas notificación',
              path: PATH_APP.notificationRules,
              permissions: 'admin:notifications:manage'
            },
            {
              title: 'Historial envíos',
              path: PATH_APP.notificationDispatches,
              permissions: 'admin:notifications:dispatches:view'
            },
          ]
        },
      ],
    },
    {
      subheader: 'Maestros',
      items: [
        {
          title: 'Clientes',
          path: PATH_APP.clients,
          icon: ICONS.user,
          permissions: 'admin:clients:list'
        },
        {
          title: 'Productos',
          path: PATH_APP.products,
          icon: ICONS.product,
          permissions: 'admin:products:list'
        },
        {
          title: 'Listas de precios',
          path: PATH_APP.priceLists,
          icon: ICONS.priceList,
          permissions: 'admin:price_lists:list'
        },
        {
          title: 'Monedas',
          path: PATH_APP.currencies,
          icon: ICONS.currency,
          permissions: 'admin:currencies:list'
        },

      ]
    },
    {
      subheader: 'Módulos',
      items: [

        {
          title: 'Contratos',
          path: PATH_APP.contracts,
          icon: ICONS.contract,
          permissions: 'admin:contracts:list'
        },
        {
          title: 'Inbox Chat',
          path: PATH_APP.chatInbox,
          icon: ICONS.chat,
          permissions: 'admin:chat_inbox:list'
        },
        ...(showQuotes
          ? [
            {
              title: 'Cotizaciones',
              path: PATH_APP.quotes,
              icon: ICONS.quoteDoc,
              permissions: 'admin:quotes:list'
            }
          ]
          : []),
        ...(showAreaCalendar
          ? [
            {
              title: 'Calendario',
              path: PATH_APP.areaCalendar,
              icon: ICONS.calendar,
              permissions: 'admin:area_calendar:list'
            }
          ]
          : []),
        {
          title: 'Requerimientos',
          path: PATH_APP.requirements,
          icon: ICONS.requirement,
          permissions: 'admin:requirements:list'
        },
        ...(showAreaKanban
          ? [
            {
              title: 'Kanban',
              path: PATH_APP.kanban,
              icon: ICONS.kanbanCompact,
              permissions: 'admin:kanban:boards:list'
            }
          ]
          : []),
        ...(showAreaPostIt
          ? [
            {
              title: 'Post-It',
              path: PATH_APP.areaPostIts,
              icon: ICONS.postit,
              permissions: 'admin:area_post_its:list'
            }
          ]
          : [])
      ]
    },
    {
      subheader: 'DESARROLLADOR',
      items: [
        {
          title: 'Sistemas',
          path: PATH_APP.releaseSystems,
          icon: ICONS.release,
          permissions: 'admin:releases_systems:list'
        },
        {
          title: 'Paquetes de Despliegue',
          path: PATH_APP.infraDeploymentPacks,
          icon: ICONS.infraPack,
          permissions: 'admin:infra:view'
        },
        {
          title: 'Servidores',
          path: PATH_APP.infraServers,
          icon: ICONS.infraServer,
          permissions: 'admin:infra:view'
        },
        {
          title: 'Configuración Infra/Release',
          path: PATH_APP.infraSettings,
          icon: ICONS.infraSettings,
          permissions: 'admin:infra:manage'
        },
        {
          title: 'Unidades Runtime',
          path: PATH_APP.infraRuntimeUnits,
          icon: ICONS.infraRuntime,
          permissions: 'admin:infra:view'
        },
        {
          title: 'Enlaces de Clientes',
          path: PATH_APP.infraTenantBindings,
          icon: ICONS.infraBinding,
          permissions: 'admin:infra:view'
        },
        {
          title: 'Operaciones',
          path: PATH_APP.infraOperations,
          icon: ICONS.infraOps,
          permissions: 'admin:infra:view'
        },
        {
          title: 'Agenda Operativa',
          path: PATH_APP.infraOperationSchedules,
          icon: ICONS.infraSchedule,
          permissions: 'admin:infra:schedule'
        },
        {
          title: 'Dashboard de Infraestructura',
          path: PATH_APP.infraDashboard,
          icon: ICONS.infraDashboard,
          permissions: 'admin:infra:view'
        },
        {
          title: 'Alertas',
          path: PATH_APP.infraAlerts,
          icon: ICONS.infraAlert,
          permissions: 'admin:infra:view'
        },
        {
          title: 'Versiones',
          path: PATH_APP.developerReleases,
          icon: ICONS.release,
          permissions: 'admin:releases:list'
        },
        {
          title: 'API de Integración',
          path: PATH_APP.developerEnpisoApi,
          icon: ICONS.api,
          permissions: 'admin:api:manage'
        }
      ]
    },
    {
      subheader: 'Seguridad',
      icon: ICONS.security,
      items: [
        {
          title: 'Usuarios',
          path: PATH_APP.securityUsers,
          permissions: 'admin:security_users:list'
        },
        {
          title: 'Roles y permisos',
          path: PATH_APP.securityRoles,
          permissions: 'admin:security_roles:list'
        },
        {
          title: 'Cambiar contraseña',
          path: PATH_APP.securityChangePassword,
          permissions: 'admin:security:change_password'
        }
      ]
    }
  ];

export default buildSidebarConfig;
